import {Badge} from "@mantine/core";

// MeterStatus four-state (FNP-214): DRAFT / ACTIVE / DEPRECATED / RETIRED.
export const StatusBadge = ({status}: { status: string }) => {
    let color = 'blue';
    if (status === 'ACTIVE') {
        color = 'green';
    } else if (status === 'DEPRECATED') {
        color = 'gray';
    } else if (status === 'RETIRED') {
        color = 'red';
    }
    return <Badge color={color}>{status}</Badge>;
};
